export enum AUTH_EVENTS {
  SIGN_IN_WITH_GOOGLE_SUCCESS = 'continue_with_google_success',
  SIGN_IN_WITH_APPLE_SUCCESS = 'continue_with_apple_success',
  SIGN_IN_WITH_EMAIL_PRESSED = 'continue_with_email_pressed',
  SIGN_IN = 'sign_in',
  SIGN_UP = 'sign_up',
  CLICK_SIGN_UP_BUTTON = 'sign_up_button_pressed',
  SIGN_UP_ERROR = 'sign_up_error',
  SIGN_UP_ERROR_STALE_DATA = 'sign_up_error_stale_data',
  EMAIL_CONFIRM_RESEND_PRESS = 'EmailConfirm_ResendPress',
}

export enum SCREENS {
  SIGN = 'Sign',
}
